export class Type {
    _name;
    _condition;
    get name() {
        return typeof this._name == "function" ? this._name() : this._name;
    }
    get condition() {
        return typeof this._condition == "function" ? this._condition() : this._condition;
    }
    optional() {
        return new IslyOptional(this);
    }
    readonly() {
        return new IslyReadonly(this);
    }
    array(...options) {
        return array(this, ...options);
    }
    constructor(_name, _condition) {
        this._name = _name;
        this._condition = _condition;
    }
    get(value) {
        return this.is(value) ? this.getValue(value) : undefined;
    }
    getValue(value) {
        return value;
    }
    flaw = (value) => {
        return this.is(value)
            ? {
                type: this.name,
                ...(this.condition ? { condition: this.condition } : undefined),
                isFlaw: false,
                message: "This type is correct.",
            }
            : {
                ...(this.condition ? { condition: this.condition } : undefined),
                ...this.createFlaw(value),
                type: this.name,
            };
    };
    createFlaw(value) {
        return {};
    }
    createFlawFromType(backend, value) {
        return "createFlaw" in backend && typeof backend.createFlaw == "function"
            ? backend.createFlaw(value)
            : backend.flaw(value);
    }
}
export class IslyOptional extends Type {
    backend;
    class = "optional";
    constructor(backend) {
        super(() => backend.name + " | undefined", backend.condition);
        this.backend = backend;
    }
    is = (value) => value == undefined || this.backend.is(value);
    createFlaw(value) {
        return this.createFlawFromType(this.backend, value);
    }
}
export class IslyReadonly extends Type {
    backend;
    class = "readonly";
    constructor(backend) {
        super(() => `Readonly<${backend.name}>`, backend.condition);
        this.backend = backend;
    }
    is = (value) => value == undefined || this.backend.is(value);
    createFlaw(value) {
        return this.createFlawFromType(this.backend, value);
    }
}
export function array(itemType, ...options) {
    return new IslyArray(itemType, options);
}
const criteriaFunctions = {
    length: {
        is: (value, optionValue) => value.length == optionValue,
        condition: optionValue => `length == ${optionValue}`,
    },
    minLength: {
        is: (value, optionValue) => value.length >= optionValue,
        condition: optionValue => `minLength == ${optionValue}`,
    },
    maxLength: {
        is: (value, optionValue) => value.length <= optionValue,
        condition: optionValue => `maxLength == ${optionValue}`,
    },
};
export class IslyArray extends Type {
    itemType;
    options;
    class = "array";
    constructor(itemType, options) {
        super(() => this.baseName() + "[]", options.length > 0 ? options.map(c => criteriaFunctions[c.criteria].condition(c.value)).join(" & ") : undefined);
        this.itemType = itemType;
        this.options = options;
    }
    baseName() {
        return this.itemType.name.includes(" ") ? `(${this.itemType.name})` : this.itemType.name;
    }
    itemName(index) {
        return `${this.baseName()}[${index}]`;
    }
    is = (value) => globalThis.Array.isArray(value) &&
        this.options.every(option => criteriaFunctions[option.criteria].is(value, option.value)) &&
        value.every(item => this.itemType.is(item));
    createFlaw(value) {
        const flaws = (globalThis.Array.isArray(value) &&
            value.flatMap((item, index) => {
                const subFlaw = this.itemType.flaw(item);
                return subFlaw.isFlaw ?? true ? [{ ...subFlaw, type: this.itemName(index) }] : [];
            })) ||
            [];
        return {
            ...(flaws.length > 0 ? { flaws } : undefined),
        };
    }
    getValue(value) {
        return value.map(item => this.itemType.get(item));
    }
}
//# sourceMappingURL=index.js.map